import React, { useEffect, useState, useRef } from 'react';
import {
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { taxonomyServices } from 'api/services';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { MainTemplate } from 'shared/MainTemplate/MainTemplate';
import { IResTaxonomy } from 'api/services/taxonomies/types';
import handleNotification from 'helpers/handleNotification';
import getImageByImageSize from 'helpers/getImageByImageSize';
import Confirmation from 'shared/Confirmation/Confirmation';
import redirect from 'helpers/redirect';
import { useSelector } from 'react-redux';
import { AppState } from 'store/store';

import './TaxonomiesPage.sass';

export const TaxonomiesPage: React.FC = () => {
	const [taxonomies, setTaxonomies] = useState<IResTaxonomy[]>([]);
	const { currentLang } = useSelector((state: AppState) => state.langReducer);
	const { user } = useSelector((state: AppState) => state.userReducer);
	const [taxonomyId, setTaxonomyId] = useState<number | undefined>();
	const confirmation = useRef<any>();

	useEffect(() => {
		if (user) redirect(user?.role);
	}, [user?.role]);

	useEffect(() => {
		if (currentLang?.code) getTaxonomies();
	}, [currentLang?.code]);

	const getTaxonomies = async () => {
		const res = await taxonomyServices.getTaxonomies().then((res) => res.data);
		setTaxonomies(res);
	};

	const deleteTaxonomy = async () => {
		if (!taxonomyId) return;
		await taxonomyServices.deleteTaxonomy(taxonomyId).then((res) => res.data);
		handleNotification('Удалено', 'success');
		getTaxonomies();
	};

	const clearId = () => {
		setTaxonomyId(undefined);
	};

	return (
		<>
			<Confirmation
				title='Удалить'
				text='Вы действительно хотите удалить таксономию?'
				submit={deleteTaxonomy}
				changeState={clearId}
				ref={confirmation}
			/>
			<MainTemplate title='Таксономии' url='/taxonomies/create'>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Заголовок</TableCell>
							<TableCell>Навание</TableCell>
							<TableCell>Изображение</TableCell>
							<TableCell>Дата изменения</TableCell>
							<TableCell className='table-last-item'>Редактировать</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{taxonomies?.map((i) => (
							<TableRow key={i.id}>
								<TableCell>{i.title}</TableCell>
								<TableCell>{i.name}</TableCell>
								<TableCell>
									<div className='page-table__image'>
										<img
											src={getImageByImageSize({ src: i.file?.src })}
											alt=''
										/>
									</div>
								</TableCell>
								<TableCell>
									{moment(i.updatedAt).format('DD.MM.YYYY HH:mm')}
								</TableCell>
								<TableCell className='table-last-item'>
									<Link
										to={`/taxonomies/${i.id}`}
										className='table-icon table-icon--black'>
										<EditIcon />
									</Link>
									<DeleteForeverIcon
										color='secondary'
										className='table-icon'
										onClick={() => {
											confirmation.current.onShow();
											setTaxonomyId(i.id);
										}}
									/>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</MainTemplate>
		</>
	);
};
